import React, { useState, useRef, useEffect } from "react";
import {
  Form,
  InputGroup,
  ListGroup,
  Button,
  Container,
} from "react-bootstrap";
import Search from "../assets/images/search-icon.svg";
import Location from "../assets/images/location-icon.svg";
import { ASSETS_URL } from "../api/constants";
import { useNavigate } from "react-router-dom";
import useSuburbs from "../hooks/useSuburbs";
import useBanners from "../hooks/useBanners";

function HomeBanner() {
  const { banners } = useBanners();
  const navigate = useNavigate();
  const inputGroupRef = useRef(null);

  const [inputHeight, setInputHeight] = useState(0);
  const [query, setQuery] = useState("");
  const [filtered, setFiltered] = useState([]);
  const [currentBanner, setCurrentBanner] = useState(0);

  const { suburbs } = useSuburbs();

  // Rotate banners every 5 seconds
  useEffect(() => {
    if (!banners || banners.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentBanner((prev) => (prev + 1) % banners.length);
    }, 15000);

    return () => clearInterval(interval);
  }, [banners]);

  const current = banners[currentBanner];

  const displayPageName =
    current?.name || "Find the right home<br> at the right price";

  const bannerStyle = {
    backgroundImage: current ? `url(${ASSETS_URL}${current.icon})` : undefined,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    backgroundSize: "cover",
  };

  useEffect(() => {
    if (inputGroupRef.current) {
      setInputHeight(inputGroupRef.current.offsetHeight);
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (inputGroupRef.current) {
        setInputHeight(inputGroupRef.current.offsetHeight);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleChange = (e) => {
    const value = e.target.value;
    setQuery(value);

    if (value.length > 0) {
      const results = suburbs.filter((item) =>
        item.toLowerCase().includes(value.toLowerCase()),
      );
      setFiltered(results);
    } else {
      setFiltered([]);
    }
  };

  const handleSelect = (item) => {
    setQuery(item);
    setFiltered([]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!query) return;

    const suburbName = query.split(",")[0].trim();

    try {
      navigate("/search?suburb=" + encodeURIComponent(suburbName));
    } catch (err) {
      console.error("Search error:", err);
    }
  };

  return (
    <div className="home-banner" style={bannerStyle}>
      <Container>
        <h1
          key={currentBanner}
          dangerouslySetInnerHTML={{ __html: displayPageName }}
        />

        <Form onSubmit={handleSubmit}>
          <InputGroup ref={inputGroupRef}>
            <Form.Control
              type="search"
              placeholder="Enter a suburb or city"
              value={query}
              onChange={handleChange}
            />

            <Button type="submit">
              <img src={Search} alt="" />
            </Button>
          </InputGroup>

          {filtered.length > 0 && (
            <ListGroup
              style={{
                top: inputHeight + 4,
              }}
            >
              {filtered.map((item, index) => (
                <ListGroup.Item
                  key={index}
                  action
                  onClick={() => handleSelect(item)}
                >
                  <img src={Location} alt="" /> {item}
                </ListGroup.Item>
              ))}
            </ListGroup>
          )}
        </Form>
        {banners.length > 1 && (
          <div className="banner-dots">
            {banners.map((_, index) => (
              <button
                key={index}
                type="button"
                className={`banner-dot ${
                  currentBanner === index ? "active" : ""
                }`}
                onClick={() => setCurrentBanner(index)}
                aria-label={`Go to banner ${index + 1}`}
              />
            ))}
          </div>
        )}
      </Container>
    </div>
  );
}

export default HomeBanner;
